import './App.css';
// import Result from './components/Result';
import Rating from './components/rating/Rating';
// import { useState } from 'react';
function App() {
 
  return (
    <div className="">
      
       <Rating />
       
    </div>
  );
}

export default App;
